export type PromptMode = "registry" | "inline";

interface ModeToggleProps {
  mode: PromptMode;
  onModeChange: (mode: PromptMode) => void;
  disabled?: boolean;
}

export const ModeToggle = ({ mode, onModeChange, disabled }: ModeToggleProps) => (
  <div className="inline-flex rounded-lg bg-gray-100 p-0.5">
    <button
      type="button"
      onClick={() => onModeChange("registry")}
      disabled={disabled}
      className={`rounded-md px-3 py-1.5 text-xs font-medium transition-all ${
        mode === "registry"
          ? "bg-white text-gray-900 shadow-sm"
          : "text-gray-500 hover:text-gray-700"
      } ${disabled ? "cursor-not-allowed opacity-50" : ""}`}
    >
      Registry
    </button>
    <button
      type="button"
      onClick={() => onModeChange("inline")}
      disabled={disabled}
      className={`rounded-md px-3 py-1.5 text-xs font-medium transition-all ${
        mode === "inline" ? "bg-white text-gray-900 shadow-sm" : "text-gray-500 hover:text-gray-700"
      } ${disabled ? "cursor-not-allowed opacity-50" : ""}`}
    >
      Inline
    </button>
  </div>
);
